<form [formGroup]="baseFormGroup" #f="ngForm">

  <div class="form-group row">
    <div class="col-lg-2">
      <yt-number-input-v3
      name="txtUgovorenaKolicina"
      formControlName="UgovorenaKolicina"
      [Label]="'KOMITENTUGOVORSTAVKA.UGOVORENAKOLICINA.SINGULAR'">
    </yt-number-input-v3>
      <div class="form-error" *ngIf="submitted && fc.UgovorenaKolicina.invalid">
        <span *ngFor="let validation of errorMessages.UgovorenaKolicina">
            <span class="error-message" *ngIf="fc.UgovorenaKolicina.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-lg-2">
      <yt-dropdown-picklist 
      [ModelName]="'jedinicamere'" 
      [GetName]="'get'" 
      [ModelProperty]="'Oznaka,Naziv'" 
      [OrderBy]="'Naziv'"
      [AllowAddNew]="false" 
      formControlName="UgovorenaJedinicaMereId" 
      [Label]="'KOMITENTUGOVORSTAVKA.UGOVORENAJEDINICAMERE.SINGULAR'">
      >
    </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.UgovorenaJedinicaMereId.invalid">
        <span *ngFor="let validation of errorMessages.UgovorenaJedinicaMereId">
          <span class="error-message" *ngIf="fc.UgovorenaJedinicaMereId.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-lg-2">
      <yt-number-input-v3
      name="txtUgovorenaCena"
      formControlName="UgovorenaCena"
      [Label]="'KOMITENTUGOVORSTAVKA.UGOVORENACENA.SINGULAR'">
    </yt-number-input-v3>
      <div class="form-error" *ngIf="submitted && fc.UgovorenaCena.invalid">
        <span *ngFor="let validation of errorMessages.UgovorenaCena">
            <span class="error-message" *ngIf="fc.UgovorenaCena.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <!-- <div class="col-lg-2">
      <yt-number-input-v3
      name="txtUgovorenaVrednost"
      formControlName="UgovorenaVrednost"
      [Label]="'KOMITENTUGOVORSTAVKA.UGOVORENAVREDNOST.SINGULAR'">
    </yt-number-input-v3>
      <div class="form-error" *ngIf="submitted && fc.UgovorenaVrednost.invalid">
        <span *ngFor="let validation of errorMessages.UgovorenaVrednost">
            <span class="error-message" *ngIf="fc.UgovorenaVrednost.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div> -->
    <div class="col-lg-2">
      <yt-dropdown-picklist 
      [ModelName]="'valuta'" 
      [GetName]="'get'" 
      [ModelProperty]="'Naziv,Sifra,ISOAlpha3Code'" 
      [OrderBy]="'Naziv'"
      [AllowAddNew]="false" 
      formControlName="UgovorenaVrednostValutaId" 
      [Label]="'KOMITENTUGOVORSTAVKA.UGOVORENAVREDNOSTVALUTA.SINGULAR'"
      [Width]="'l'"
      [Position]="'left'"
      [FilterByAllColumns]="false"
      >
    </yt-dropdown-picklist>
     <div class="form-error" *ngIf="submitted && fc.UgovorenaVrednostValutaId.invalid">
       <span *ngFor="let validation of errorMessages.UgovorenaVrednostValutaId">
         <span class="error-message" *ngIf="fc.UgovorenaVrednostValutaId.hasError(validation.type)">
           <span translate="{{ validation.message }}"></span>
         </span>
       </span>
     </div>
    </div>
    <div class="col-lg-2">
      <yt-number-input-v3
      name="txtCenaDodatnogPosla"
      formControlName="CenaDodatnogPosla"
      [Label]="'KOMITENTUGOVORSTAVKA.CENADODATNOGPOSLA.SINGULAR'">
    </yt-number-input-v3>
      <div class="form-error" *ngIf="submitted && fc.CenaDodatnogPosla.invalid">
        <span *ngFor="let validation of errorMessages.CenaDodatnogPosla">
            <span class="error-message" *ngIf="fc.CenaDodatnogPosla.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-lg-2">
      <yt-dropdown-picklist 
      [ModelName]="'valuta'" 
      [GetName]="'get'" 
      [ModelProperty]="'Naziv,Sifra,ISOAlpha3Code'" 
      [OrderBy]="'Naziv'"
      [AllowAddNew]="false" 
      formControlName="CenaDodatnogPoslaValutaId" 
      [Label]="'KOMITENTUGOVORSTAVKA.CENADODATNOGPOSLAVALUTA.SINGULAR'"
      [Width]="'l'"
      [Position]="'left'"
      [Required]="false">
    </yt-dropdown-picklist>
     <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
      <span class="error-message"
        *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControls && !this.baseFormGroup.errors.checkControls.valid"><span
          translate="{{this.baseFormGroup.errors.checkControls.message}}"></span></span>
      </div>
    </div>
</div>

<div class="form-group row">
  <div class="col-lg-12">
  <yt-input 
  [Type]="'text'" 
  [Label]="'KOMITENTUGOVORSTAVKA.OPIS.SINGULAR'" 
  formControlName="Opis" 
  [ngClass]="{'is-invalid': submitted && fc.Opis.invalid}">
</yt-input>
</div>
</div>

</form>